<template>
  <div v-if="storeData" class="egift-container">
    <span class="store-name">{{storeData.store_display_name}}</span>
    <div class="row-info mt15">
      <span>{{storeData.store_display_address}}</span>
    </div>
    <a :href="`tel:${storeData.store_display_phone}`" class="row-info mt10">
      <span>{{storeData.store_display_phone}}</span>
    </a>
    <a :href="storeData.store_main_url" class="row-info mt10">
      <span>{{storeData.store_main_url}}</span>
    </a>
    <img :src="storeData.logo_url" class="store-logo" />
    <gift-item
      v-for="(item, index) in storeData.egift_cards"
      :key="item.id"
      :item="item"
      :isActive="selectedIndex === index"
      v-on:onItemClick="onSelectedItem(index)"
    />
    <span class="view-menu normal-button" @click="showStoreMenu">View Menu</span>
    <div class="gift-detail-container">
      <span class="title">Redemption Detail</span>
      <div class="detail">
        <div v-for="(text,index) in eGiftCardDescription" :key="index">
          <span v-if="text != ''">{{text}}</span>
          <br v-else />
        </div>
        <div class="social-view" v-if="storeData.store_facebook_url != null">
          <img class="social-logo" src="@/assets/logofacebook.png" />
          <a :href="storeData.store_facebook_url">
            <span class="social-name">{{getFacebookName}}</span>
          </a>
        </div>
        <div class="social-view" v-if="storeData.store_instagram_url != null">
          <img class="social-logo" src="@/assets/logoinstag.png" />
          <a :href="storeData.store_instagram_url">
            <span class="social-name">{{getInstagramName}}</span>
          </a>
        </div>
      </div>
    </div>
    <gradient-button class="cta-bottom" :title="buttonTitle" @onClick="onAddToCartClick" />
    <transition name="fade">
      <div v-if="toggleBottom" class="overlay" />
    </transition>
    <transition name="slide">
      <bottom-checkout
        v-if="toggleBottom"
        class="bottom-checkout"
        @onContinueClick="toggleBottom = !toggleBottom"
      />
    </transition>
    <div v-if="showMenu" class="store-menu-view" @click="hideStoreMenu">
      <img :src="storeData.store_menu" class="img-menu" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getSubDomain } from "@/utils/parser";
import GiftItem from "./components/GiftItem";
import GradientButton from "@/components/GradientButton";
import BottomCheckout from "./components/BottomCheckout";
import store from "@/store";
import { getNameFromUrl } from "@/utils/parser";
export default {
  name: "eGiftCard",
  data() {
    return {
      buttonTitle: "Add to Cart",
      toggleBottom: false,
      showMenu: false
    };
  },
  components: {
    GiftItem,
    GradientButton,
    BottomCheckout
  },
  computed: {
    ...mapGetters(["storeData", "selectedIndex"]),
    eGiftCardDescription() {
      if (!store.state.eGiftCard.dataStore.redemption_details) return [];
      return store.state.eGiftCard.dataStore.redemption_details.split("\n");
    },
    getFacebookName() {
      return getNameFromUrl(store.state.eGiftCard.dataStore.store_facebook_url);
    },
    getInstagramName() {
      return getNameFromUrl(
        store.state.eGiftCard.dataStore.store_instagram_url
      );
    }
  },
  created() {
    const fullUrl = window.location.origin;
    const storeName = getSubDomain(fullUrl);
    store
      .dispatch("eGiftCard/getData", storeName || "classynails")
      .then(res => {
        document.title = `${res.store_display_name} eGift Card`;
      });
  },
  methods: {
    showStoreMenu() {
      this.showMenu = true;
    },
    hideStoreMenu() {
      this.showMenu = false;
    },
    onSelectedItem: index => {
      store.dispatch("eGiftCard/setSelectedIndex", index);
    },
    onAddToCartClick() {
      this.toggleBottom = !this.toggleBottom;
      const list = this.storeData.egift_cards;
      const item = list[this.selectedIndex];
      store.dispatch("cart/addToCart", item);
    }
  }
};
</script>
<style lang="scss" scoped>
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(295px);
}
.egift-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 70px;
  padding-right: 70px;
  background-color: white;
  .store-name {
    font-size: 24px;
    font-family: "SFProText-Semibold", -apple-system;
    font-weight: 600;
    margin-top: 50px;
    align-self: center;
  }
  .row-info {
    display: flex;
    align-items: center;
    justify-content: center;
    .info-logo {
      height: 18px;
      width: auto;
    }
  }

  .store-logo {
    border-radius: 7.5px;
    box-shadow: 0 4px 8px rgba($color: #000000, $alpha: 0.2);
    margin: 50px 0;
    align-self: center;
    width: 210px;
    height: auto;
  }

  .view-menu {
    font-family: "SFProText-Semibold" -apple-system;
    font-weight: 600;
    font-size: 16px;
    color: #2e2323;
    align-self: center;
    margin-top: 40px;
  }
  .gift-detail-container {
    margin: 20px 20px 0 20px;
    padding-top: 30px;
    padding-bottom: 120px;
    border-top: 1px solid #979797;
    display: flex;
    flex: 1;
    flex-direction: column;
    .title {
      color: #4a4a4a;
      font-size: 16px;
      font-family: "SFProText-Bold", -apple-system;
      font-weight: bold;
    }
    .detail {
      color: #4a4a4a;
      font-size: 16px;
      font-family: "SFProText-Medium", -apple-system;
      font-weight: 500;
      margin-top: 24px;
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-bottom: 5px;
      .social-view {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 20px;
        .social-logo {
          width: 25px;
          height: auto;
          margin-right: 10px;
        }
        .social-name {
          font-size: 16px;
        }
      }
    }
  }
  .cta-bottom {
    position: fixed;
    left: calc(50% - 250px);
    right: calc(50% - 250px);
    bottom: 30px;
  }
  .bottom-checkout {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
  .img-menu {
    max-width: 100%;
    max-height: 100vh;
    width: auto;
    height: auto;
  }
  .store-menu-view {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media only screen and (max-width: 600px) {
  .egift-container {
    padding-left: 0;
    padding-right: 0;
    .cta-bottom {
      left: 20px;
      right: 20px;
    }
  }
}
</style>